import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./testimonials.css";

function Testimonials() {
  const reviews = [
    { name: "Priya Sharma", text: "The lehenga I bought was stunning! Truly made my wedding special." },
    { name: "Rahul Mehta", text: "Sherwani was elegant and comfortable. Highly recommended!" },
    { name: "Sneha Patel", text: "Amazing collection and great service. Loved it!" },
  ];

  return (
    <section className="testimonials" id="testimonials">
      <h2>WHAT OUR CLIENTS SAY!</h2>

      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        autoplay={{ delay: 1000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop={true}
      >
        {reviews.map((r, i) => (
          <SwiperSlide key={i}>
            <div className="review">
              <p>"{r.text}"</p>
              <h4>- {r.name}</h4>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Testimonials;
